import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider, App } from "antd";
import { IconProvider } from "@ant-design/icons";
const Provider = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx(ConfigProvider, {
        prefixCls: process.env.ANTD_PREFIX,
        iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
        theme: {
            token: {
                colorPrimary: "#2271b1",
                borderRadius: 3
            }
        },
        children: /*#__PURE__*/ _jsx(IconProvider, {
            value: {
                prefixCls: `${process.env.ANTD_PREFIX}-anticon`
            },
            children: /*#__PURE__*/ _jsx(App, {
                children: children
            })
        })
    });
};
export { Provider };
